import { StrikeThroughHeader } from '../StrikethroughHeader/strikethrough-header';

const WizardBase = ({ title, children }) => {
  return (
    <div style={{ width: '50%' }}>
      <StrikeThroughHeader>{title}</StrikeThroughHeader>
      {children}
    </div>
  );
};

export { WizardBase };
